import { render, staticRenderFns } from "./OilPrice.vue?vue&type=template&id=72228dac&scoped=true"
import script from "./OilPrice.vue?vue&type=script&lang=js"
export * from "./OilPrice.vue?vue&type=script&lang=js"
import style0 from "./OilPrice.vue?vue&type=style&index=0&id=72228dac&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72228dac",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\XWork\\ProjectSystem\\铂诺客SaaS\\devicenewweb\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('72228dac')) {
      api.createRecord('72228dac', component.options)
    } else {
      api.reload('72228dac', component.options)
    }
    module.hot.accept("./OilPrice.vue?vue&type=template&id=72228dac&scoped=true", function () {
      api.rerender('72228dac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Basics/BasicsEnergyPrice/OilPrice/OilPrice.vue"
export default component.exports